window.SlickSettings = (function() {

	var ret = {};

	function slickInit() {
		var h2 = $(this).parent().find(".header h2");
		if (h2.length === 0) {
			h2 = $(this).parent().find("h2").first();
		}
		if (h2.length === 0) {
			h2 = $(this).closest(".eventSlideshow").find(".header h2").first();
		}
		if (h2.length > 0) {
			var slickTrack = $(this).find(".slick-track");
			var id = h2.attr("id");
			if (!id) {
				slickTrack.attr("aria-label", h2.text());
			} else {
			    slickTrack.attr("aria-labelledby", id);
			}
		}
	}

	function slickAfterInit() {
	    // Remove aria-describedby attributes here since they refer to elements created by the "dots" feature which isn't needed or required here and should be disabled.
	    removeAriaDescribedby();
	    removeAriaLabelledBy();
	}

	function removeAriaDescribedby() {
	    $(document)
            .find('.slick-slide')
	        .each(function () {
	            $(this).removeAttr('aria-describedby');
	        });
	}

	function removeAriaLabelledBy() {
        $(document)
            .find('.slick-track')
            .each(function () {
                var el = $(this);
                if (el.attr("aria-label") && el.attr("aria-labelledby"))
                    el.removeAttr("aria-labelledby");
            });
    }

	ret.slickInit = slickInit;
	ret.slickAfterInit = slickAfterInit;
	ret.removeAriaDescribedby = removeAriaDescribedby;
	ret.removeAriaLabelLedBy = removeAriaLabelledBy;
	return ret;

})();